import { render, staticRenderFns } from "./index.vue?vue&type=template&id=72a7c3fd&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/PC.scss?vue&type=style&index=0&id=72a7c3fd&prod&lang=scss&scoped=true&external"
import style1 from "./index.vue?vue&type=style&index=1&id=72a7c3fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a7c3fd",
  null
  
)

export default component.exports